<template>
  <v-container fluid>
    <v-row class="mb-12">
      <v-col cols="12" class="text-center">
        <h3>Oups ! Vous n'avez pas accès à cette fonctionnalité</h3>
        <h2 class="primary--text">Profitez de nos offres</h2>
      </v-col>
      <template>
        <v-col cols="12" lg="4" v-if="iOS">
          <v-card
            :target="iOS ? null : '_blank'"
            @click="iOS ? storeOrder('myweekly') : null"
            :href="
              iOS
                ? null
                : 'https://services.previmeteo.com/fr/abonnement-bulletin-meteo.php'
            "
            color="primary"
            elevation="0"
          >
            <v-card-text>
              <h2>My semaine</h2>
              <span class="white--text text-h5">
                <template v-if="!iOS">7.99 € / semaine</template>
                <template v-else>7.99 € / semaine</template>
              </span>
              <ul style="list-style: none">
                <li>
                  <v-icon color="success">mdi-check</v-icon>1 accès par
                  utilisateur
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Ville au choix
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Prévisions heure par
                  heure
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Météo à 5 jours
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Une pré-alerte
                  quotidienne pour une ville
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Connexion station
                  météo en option
                </li>
                <li>
                  <v-icon color="error">mdi-close</v-icon>Pas de cartes
                  techniques
                </li>
                <li>
                  <v-icon color="error">mdi-close</v-icon>Pas d'alerte temps
                  réel pour les précipitations
                </li>
                <li>
                  <v-icon color="error">mdi-close</v-icon>Pas de bulletin par
                  email
                </li>
                <li>
                  <v-icon color="error">mdi-close</v-icon>Pas de radar de
                  précipitations
                </li>
                <li>
                  <v-icon color="error">mdi-close</v-icon>Pas d'image satellite
                </li>
              </ul>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" lg="4" v-if="iOS">
          <v-card
            :target="iOS ? null : '_blank'"
            @click="iOS ? storeOrder('myplusweekly') : null"
            :href="
              iOS
                ? null
                : 'https://services.previmeteo.com/fr/abonnement-bulletin-meteo.php'
            "
            color="grey lighten-4"
            elevation="0"
          >
            <v-card-text>
              <h2>My + Semaine</h2>
              <span class="text-h5">
                <template v-if="!iOS">17,99 € / semaine</template>
                <template v-else>17,99 € / semaine</template>
              </span>
              <ul style="list-style: none">
                <li>
                  <v-icon color="success">mdi-check</v-icon>1 accès par
                  utilisateur
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Ville au choix
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Prévisions heure par
                  heure
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Météo à deux
                  semaines (14 jours)
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Jusqu'à 4
                  pré-alertes quotidiennes pour une ville
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Connexion station
                  météo en option
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Cartes météo
                  techniques
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Alerte temps réel
                  pluie/neige sur une ville
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Bulletins météo
                  détaillé par email pour une ville
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Radar de
                  précipitations
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Image satellite
                </li>
              </ul>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" lg="4">
          <v-card
            :target="iOS ? null : '_blank'"
            @click="iOS ? storeOrder('my') : null"
            :href="
              iOS
                ? null
                : 'https://services.previmeteo.com/fr/abonnement-bulletin-meteo.php'
            "
            color="primary"
            elevation="0"
          >
            <v-card-text>
              <h2>My</h2>
              <span class="white--text text-h5">
                <template v-if="!iOS">19,00 € HT / mois</template>
                <template v-else>22,99 € / mois</template>
              </span>
              <ul style="list-style: none">
                <li>
                  <v-icon color="success">mdi-check</v-icon>1 accès par
                  utilisateur
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Ville au choix
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Prévisions heure par
                  heure
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Météo à 5 jours
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Une pré-alerte
                  quotidienne pour une ville
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Connexion station
                  météo en option
                </li>
                <li>
                  <v-icon color="error">mdi-close</v-icon>Pas de cartes
                  techniques
                </li>
                <li>
                  <v-icon color="error">mdi-close</v-icon>Pas d'alerte temps
                  réel pour les précipitations
                </li>
                <li>
                  <v-icon color="error">mdi-close</v-icon>Pas de bulletin par
                  email
                </li>
                <li>
                  <v-icon color="error">mdi-close</v-icon>Pas de radar de
                  précipitations
                </li>
                <li>
                  <v-icon color="error">mdi-close</v-icon>Pas d'image satellite
                </li>
              </ul>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" lg="4">
          <v-card
            :target="iOS ? null : '_blank'"
            @click="iOS ? storeOrder('myplus') : null"
            :href="
              iOS
                ? null
                : 'https://services.previmeteo.com/fr/abonnement-bulletin-meteo.php'
            "
            color="grey lighten-4"
            elevation="0"
          >
            <v-card-text>
              <h2>My +</h2>
              <span class="text-h5">
                <template v-if="!iOS">59,00 € HT / mois</template>
                <template v-else>70,99 € / mois</template>
              </span>
              <ul style="list-style: none">
                <li>
                  <v-icon color="success">mdi-check</v-icon>1 accès par
                  utilisateur
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Ville au choix
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Prévisions heure par
                  heure
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Météo à deux
                  semaines (14 jours)
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Jusqu'à 4
                  pré-alertes quotidiennes pour une ville
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Connexion station
                  météo en option
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Cartes météo
                  techniques
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Alerte temps réel
                  pluie/neige sur une ville
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Bulletins météo
                  détaillé par email pour une ville
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Radar de
                  précipitations
                </li>
                <li>
                  <v-icon color="success">mdi-check</v-icon>Image satellite
                </li>
              </ul>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" v-if="!iOS">
          <v-card target="_blank" href="https://previmeteo.com/contact.php">
            <v-card-title>Stormwatch</v-card-title>
            <v-card-text>
              Pré-alerte orage, suivi et alerte foudre en temps
              réel</v-card-text
            >
            <v-card-actions>
              <h2 class="primary--text">Contactez-nous</h2>
            </v-card-actions>
          </v-card>
        </v-col>
      </template>
    </v-row>
    <v-overlay v-model="loading">
      <v-progress-circular indeterminate />
    </v-overlay>
  </v-container>
</template>

<script>
import { Capacitor } from '@capacitor/core';
import { InAppPurchase2 } from "@ionic-native/in-app-purchase-2";
import api from "@/api";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["user"]),
    iOS() {
      return Capacitor.getPlatform() == "ios" ? true : false;
    },
  },
  data: () => ({
    store: InAppPurchase2,
    loading: false,
  }),
  methods: {
    updateRole() {
      api.users.updateRole(this.user.id_user, 2);
    },
    iapInit() {
      this.loading = true;
      try {
        this.store.verbosity = this.store.DEBUG;
        this.store.register({
          id: "my",
          type: this.store.PAID_SUBSCRIPTION,
        });
        this.store.register({
          id: "myweekly",
          type: this.store.PAID_SUBSCRIPTION,
        });
        this.store.register({
          id: "myplus",
          type: this.store.PAID_SUBSCRIPTION,
        });
        this.store.register({
          id: "myplusweekly",
          type: this.store.PAID_SUBSCRIPTION,
        });

        this.store.validator =
          "https://validator.fovea.cc/v1/validate?appName=com.previmeteo.alertes&apiKey=b7bf1a11-92ed-4aa6-9bf8-0b79b4f5954c";

        // Register event handlers for the specific product
        this.store.when("my").registered(async (product) => {
          console.log(product)
          this.loading = false;
        });
        this.store.when("myweekly").registered(async (product) => {
          console.log(product)
          this.loading = false;
        });

        // // Updated
        // this.store.when("my").updated(async (product) => {
        //   console.log("Updated" + JSON.stringify(product));
        // });

        // // User closed the native purchase dialog
        // this.store.when("my").cancelled((product) => {
        //   console.error("Purchase was Cancelled");
        // });

        // Register event handlers for the specific product
        this.store.when("myplus").registered(async (product) => {
          console.log(product)
          this.loading = false;
        });
        this.store.when("myplusweekly").registered(async (product) => {
          console.log(product)
          this.loading = false;
        });

        // Updated
        // this.store.when("myplus").updated(async (product) => {
        //   console.log("Updated" + JSON.stringify(product));
        // });

        this.store.when("my").approved(async (product) => {
          // download the feature
          product.finish();
          this.loading = true;
          try {
            await api.users.updateRole(this.user.id_user, 2);
            let user = await api.users.get(this.user.id_user);
            this.$store.dispatch("setUser", user);
            this.$store.dispatch("isPayed");
            this.$router.push("/?haveAccess=true");
          } catch (err) {
            console.log(err);
          }
          this.loading = false;
          // window.location.replace("/?haveAccess=true");
        });
        this.store.when("myweekly").approved(async (product) => {
          // download the feature
          product.finish();
          this.loading = true;
          try {
            await api.users.updateRole(this.user.id_user, 4);
            let user = await api.users.get(this.user.id_user);
            this.$store.dispatch("setUser", user);
            this.$store.dispatch("isPayed");
            this.$router.push("/?haveAccess=true");
          } catch (err) {
            console.log(err);
          }
          this.loading = false;
          // window.location.replace("/?haveAccess=true");
        });
        this.store.when("myplus").approved(async (product) => {
          // download the feature
          product.finish();
          this.loading = true;
          try {
            await api.users.updateRole(this.user.id_user, 3);
            let user = await api.users.get(this.user.id_user);
            this.$store.dispatch("setUser", user);
            this.$router.push("/?haveAccess=true");
          } catch (err) {
            console.log(err);
          }
          this.loading = false;
        });
        this.store.when("myplusweekly").approved(async (product) => {
          // download the feature
          product.finish();
          this.loading = true;
          try {
            await api.users.updateRole(this.user.id_user, 5);
            let user = await api.users.get(this.user.id_user);
            this.$store.dispatch("setUser", user);
            this.$router.push("/?haveAccess=true");
          } catch (err) {
            console.log(err);
          }
          this.loading = false;
        });

        // User closed the native purchase dialog
        this.store.when("myplus").cancelled((product) => {          
          console.error("Purchase was Cancelled",product);
        });

        // Track all store errors
        this.store.error((err) => {
          console.error("Store Error " + JSON.stringify(err));
        });

        // Run some code only when the store is ready to be used
        this.store.ready(() => {
          this.loading = false;
        });

        // Refresh the status of in-app products
        this.store.refresh();
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
    async storeOrder(type) {
      // To make a purchase
      this.loading = true;
      try {
        await this.store.order(type);
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.iapInit();
    });
  },
};
</script>

<style>
</style>